/**
 * JMAP 호출(reqMailBox 등) fire-and-forget 경로의 rejection 처리.
 *
 * 목적: unhandled rejection만 handled로 전환하여 Sentry 노이즈를 줄인다. 기존 동작은 바꾸지 않는다.
 * (OFFICEMAIL-WEB-ACCESS-KD: JMAP client not initialized / -J4: 내부 JMAP Failed to fetch)
 *
 * 에러 종류별 처리:
 * - AbortError: 정상 취소(SSE 재연결·페이지 전환 등) → silent
 * - 'JMAP client not initialized': 초기화 전 호출 race(KD) → 로깅만 (노이즈)
 * - TypeError(Failed to fetch): self-origin 네트워크 실패(J4) → 로깅만 (노이즈)
 * - 그 외(서버 ProblemDetails / JMAP 메서드 Error[] / 기타): **삼키지 않고 rethrow** —
 *   실제 서버 장애일 수 있으므로 기존대로 Sentry에 보고되게 한다 (은폐 금지).
 */
export function handleJmapCallError(context: string, err: unknown): void {
  const name = err != null ? (err as { name?: string }).name : undefined

  // 정상 취소 — 무시
  if (name === 'AbortError') return

  if (err instanceof Error) {
    // KD: JMAP 클라이언트 초기화 전 호출 race
    if (err.message === 'JMAP client not initialized') {
      console.warn(`[JMAP] client not initialized — skip (${context})`)
      return
    }
    // J4: self-origin fetch 네트워크 실패
    if (name === 'TypeError' && /fetch/i.test(err.message)) {
      console.warn(`[JMAP] fetch failed — skip (${context})`, err)
      return
    }
  }

  // 서버 에러/메서드 에러/기타 — 은폐 금지. 기존처럼 전파하여 보고 유지.
  throw err
}
